import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";

const Charts = props => {
  const [calibrationData, setCalibrationData] = useState([]);
  const [calibAvg, setCalibAvg] = useState([]);
  const [calibDate, setCalibDate] = useState([]);

  useEffect(() => {
    const data = props.calibrationData;
    setCalibrationData(data.reverse());
  }, [props.calibrationData]);

  useEffect(() => {
    setCalibDate([]);
    setCalibAvg([]);

    for (let i = 0; i < calibrationData.length; i++) {
      const calibratedDate =
        calibrationData[i].CalibratedOnDate instanceof Date
          ? calibrationData[i].CalibratedOnDate
          : new Date(calibrationData[i].CalibratedOnDate);

      setCalibDate(prev => [...prev, calibratedDate.toDateString()]);
      // if (i == 0 || i == 1) {
      //   setCalibAvg(prev => [...prev, 0]);
      // } else {
      // let first = !isNotExists(calibrationData[i - 2].RecordedDevice) ? calibrationData[i - 2].CalibrationAvg : convertTomm(calibrationData[i - 2].CalibrationAvg);
      // let second = !isNotExists(calibrationData[i - 1].RecordedDevice) ? calibrationData[i - 1].CalibrationAvg : convertTomm(calibrationData[i - 1].CalibrationAvg);
      // let third = !isNotExists(calibrationData[i].RecordedDevice) ? calibrationData[i].CalibrationAvg : convertTomm(calibrationData[i].CalibrationAvg);

      // let first = calibrationData[i - 2].CalibrationAvg;
      // let second = calibrationData[i - 1].CalibrationAvg;
      setCalibAvg(prev => [
        ...prev,
        roundOff(calibrationData[i].CalibrationAvg)
      ]);
    }
  }, [calibrationData]);
  // const isNotExists = (value) => [null, undefined].includes(value);

  // const convertTomm = (valueInPixel) => {
  //   return valueInPixel / 6.25;
  // };
  const roundOff = data => {
    return +(Math.round(data + "e+" + 1) + "e-" + 1);
  };

  const series = [
    {
      name: "Calibration Avg",
      data: calibAvg
    }
  ];

  const options = {
    chart: {
      height: 200,
      type: "line",
      interval: 2,
      zoom: {
        enabled: false
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: "straight"
    },
    title: {
      text: "Calibration Avg Per Day",
      align: "left"
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5
      }
    },
    xaxis: {
      categories: calibDate
    }
  };

  return (
    <>
      {calibDate && calibAvg.length > 0 ? (
        <Chart
          options={options}
          series={series}
          type="line"
          width="100%"
          height="350"
        />
      ) : (
        <div>No data available for the chart</div>
      )}
    </>
  );
};

export default Charts;
